import { render, staticRenderFns } from "./Annex15AdmissionReport.vue?vue&type=template&id=4ffd8d0d&"
import script from "./Annex15AdmissionReport.vue?vue&type=script&lang=js&"
export * from "./Annex15AdmissionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports